const widget_3 = (() => {
    const setup = () => {
      applyAllFocalPositions();
      document.addEventListener('DOMContentLoaded', applyAllFocalPositions);
      window.addEventListener('resize', applyAllFocalPositions);
    }

  function applyFocalBackgroundPosition(el) {
    const url = el.dataset.bgUrl;
    if (!url) return;

    const img = new Image();
    img.onload = () => {
      const Iw = img.naturalWidth;
      const Ih = img.naturalHeight;
      const rect = el.getBoundingClientRect();
      const Bw = rect.width;
      const Bh = rect.height;
      if (!Bw || !Bh) return;

      const scale = Math.max(Bw / Iw, Bh / Ih);
      const Dw = Iw * scale;
      const Dh = Ih * scale;

      const fx = parseFloat(el.dataset.focusX || 50) / 100;
      const fy = parseFloat(el.dataset.focusY || 50) / 100;

      let px = Dw <= Bw + 0.5 ? 0.5 : (Bw / 2 - fx * Dw) / (Bw - Dw);
      let py = Dh <= Bh + 0.5 ? 0.5 : (Bh / 2 - fy * Dh) / (Bh - Dh);

      px = Math.min(1, Math.max(0, px));
      py = Math.min(1, Math.max(0, py));

      el.style.backgroundPosition = `${(px * 100).toFixed(1)}% ${(py * 100).toFixed(1)}%`;
    };
    img.src = url;
  }

  function applyAllFocalPositions() {
    document.querySelectorAll('[data-focus-x][data-focus-y]').forEach(applyFocalBackgroundPosition);
  }

    return {
        init: () => {
            setup();
        }
    };
})()

export default widget_3;
